import { useTheme } from "@emotion/react";
import { Alert, Box, useMediaQuery } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const AnnounceChangeMonth = () => {
  const theme = useTheme();
  const isSp = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        maxWidth: "460px",
        margin: "4px auto auto",
      }}
    >
      <Alert severity="info" sx={{}}>
        月が変わりましたので、{isSp && <br />}
        新しい月の実績を表示しております。
        <br />
        先月分の実績は<Link to={"/mypage/history"}>報酬履歴</Link>
        からご確認ください。
      </Alert>
    </Box>
  );
};

export default AnnounceChangeMonth;
